import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import RichTextEditor from "./RichTextEditor";

type CommentRichTextAreaProps = {
  name: string;
  rules?: any;
  value: string;
  onChange: (value: string) => void;
  saveAsMarkdown?: boolean;
};

const CommentRichTextArea = ({
  name,
  rules,
  value,
  onChange,
  saveAsMarkdown = true // Defaulting to true for comments as per senior's request
}: CommentRichTextAreaProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onBlur }, fieldState: { error } }) => (
        <div className="w-full">
          <RichTextEditor
            value={value}
            onChange={onChange}
            compact={true}
            minHeight="180px"
            maxHeight="400px"
            placeholder="Write a comment..."
            outputFormat={saveAsMarkdown ? 'markdown' : 'html'}
            className={error ? "border-red-500 ring-red-100" : ""}
          />
          {error && (
            <p className="mt-1 text-sm text-red-500">
              {error.message || "Comment cannot be empty"}
            </p>
          )}
        </div>
      )}
    />
  );
};

export default CommentRichTextArea;
